import * as ko from 'knockout';

import BaseInputBindable from "./baseInputBindable";
import TextInputBindableArgs from './textInputBindableArgs';

export default class TextInputBindable extends BaseInputBindable {
    public readonly value: ko.Observable<string>;

    public readonly lines: ko.Observable<number>;
    public readonly isMultiline: ko.Computed<boolean>;
    public readonly inputType: ko.Observable<string> = ko.observable("text");
    public readonly placeholder: ko.Observable<string> = ko.observable("");
    public readonly automationId: ko.Observable<string> = ko.observable("");
    public readonly maxLengthValidationErrorText: ko.Observable<string> = ko.observable("");

    private readonly _validationPattern: RegExp;
    private readonly _maxLength: number;
    private readonly _submitFunc: () => void;

    constructor(args: TextInputBindableArgs) {
        super(args);

        if (args.validationPattern) {
            this._validationPattern = args.validationPattern;
        }
        else {
            this._validationPattern = null;
        }

        if (true === args.isPassword) {
            this.inputType("password");
        }

        if (args.maxLength) {
            this._maxLength = args.maxLength;
        }
        else {
            this._maxLength = 1024;
        }

        if (args.maxLengthValidationErrorText)
        {
            this.maxLengthValidationErrorText(args.maxLengthValidationErrorText);
        }

        this.value = this._createValueObservable(args.initialValue);

        if ('number' == typeof (args.lines)) {
            this.lines = ko.observable<number>(args.lines);
        }
        else {
            this.lines = ko.observable<number>(1);
        }
        this.isMultiline = ko.computed<boolean>(() => this.lines() > 1);
        this.placeholder = ko.observable(args.placeholder);
        this.automationId = ko.observable(args.automationId);

        this._submitFunc = args.submit ?? null;
    }

    public loadComplete(newValue: string, canChange?: boolean): void {
        this.value(newValue);
        this.updateCanChange(canChange);
        this.showValidationState(false);
        this.isLoading(false);
    }

    public handleKeyUp(data, event : KeyboardEvent) {

        if (event.isComposing) {
            return;
        }

        if (this._submitFunc && "Enter" === event.key)
        {
            this._submitFunc();
        }
    }

    protected _createValueObservable(initialValue: string): ko.Observable<string> {
        if (!initialValue) {
            initialValue = null;
        }

        let valueObservable: ko.Observable<string> = ko.observable<string>(initialValue);

        // When the value changes show the validation state to the user
        if (this._maxLength) {
            let extensions: ko.ObservableExtenderOptions<string> = {};
            extensions["maxLength"] = this._maxLength;
            valueObservable = valueObservable.extend(extensions);
        }

        valueObservable.subscribe((newValue) => {
            this.showValidationState(true);
            this.customValidationErrorMessage('');
        });
        
        return valueObservable;
    }

    protected hasValidationError(): boolean {
        if (super.hasValidationError())
        {
            return true;
        }

        let validationError: boolean;

        if (this.value()) {
            if (this._validationPattern) {
                validationError = !this._validationPattern.test(this.value());
            }
            else {
                validationError = false;
            }

            if(this.value().length > this._maxLength)
            {
                validationError = true;
                this.customValidationErrorMessage(this.maxLengthValidationErrorText());
            }  

        }
        else {
            validationError = this.isRequired();
        }
        return validationError;
    }
}